import { render, staticRenderFns } from "./FormModalBeds.vue?vue&type=template&id=8a5adf58&"
import script from "./FormModalBeds.vue?vue&type=script&lang=js&"
export * from "./FormModalBeds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports